const source = 'rappresentantiDataTable'
const sourceAgent = 'agentiDataTable'

function multiProspettoCicloPagamenti () {

  const keysRapp = Object.keys(this.filtered.items).filter((s) => s == source)
  //const keysAgent = Object.keys(this.filtered.items).filter((s) => s == sourceAgent)
  if(keysRapp.length > 0){
    const itemsRapp = this.filtered.items[source]
    const itemsAgent = this.filtered.items[sourceAgent]
    this.$eventBus.emit('show-dialog-page', {
      page: 'rappresentanti-multi-prospetto-ciclo-pagamenti',
      title: 'Multi Prospetto Ciclo Pagamenti',
      data: {itemsRapp, itemsAgent},
      maximize: true,
    })
  } 
}

export default {
  'bindTo': 'this',
  'method': multiProspettoCicloPagamenti,
}
